//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wxConfig from '@/assets/js/wx_config'

export default {
  name: "deskDiaryShare",
  
//   watch: {
//     isModeShow(v){
//         console.log(v)
//         this.toggleContainerTouchAction(v)
//         if (v) {
//             document.body.addEventListener('touchmove', this.stopTouch, { passive: false, capture: true })
//         } else {
//             document.body.removeEventListener('touchmove', this.stopTouch, { capture: true })
//         }
//     }  
//   },
  data(){
    return{
        btn1:require('@/assets/images/activity/button1@2x.png'),
        btn2:require('@/assets/images/activity/button2@2x.png'),
        details:[],
        isModeShow:true
    }
  },
  mounted() {
    this.$store.commit('UPDATE_HEAD',false);
    this.$store.commit('UPDATE_FOOTER',false);
    this.$store.commit('UPDATE_PAGE_TITLE','小棉花台历新年团购');
    document.title = '小棉花台历新年团购'
    this.getSharedInfo()
    this.details = [
        {url:'https://matl.oss-cn-beijing.aliyuncs.com/activity/%E5%8F%B0%E5%8E%86/1.jpg'},
        {url:'https://matl.oss-cn-beijing.aliyuncs.com/activity/%E5%8F%B0%E5%8E%86/2.jpg'},
        {url:'https://matl.oss-cn-beijing.aliyuncs.com/activity/%E5%8F%B0%E5%8E%86/3.jpg'},
        {url:'https://matl.oss-cn-beijing.aliyuncs.com/activity/%E5%8F%B0%E5%8E%86/4.jpg'},
        {url:'https://matl.oss-cn-beijing.aliyuncs.com/activity/%E5%8F%B0%E5%8E%86/5.jpg'},
        {url:'https://matl.oss-cn-beijing.aliyuncs.com/activity/%E5%8F%B0%E5%8E%86/6.jpg'},
        {url:'https://matl.oss-cn-beijing.aliyuncs.com/activity/%E5%8F%B0%E5%8E%86/7.jpg'},
        {url:'https://matl.oss-cn-beijing.aliyuncs.com/activity/%E5%8F%B0%E5%8E%86/8.jpg'},
        {url:'https://matl.oss-cn-beijing.aliyuncs.com/activity/%E5%8F%B0%E5%8E%86/9.jpg'},
        {url:'https://matl.oss-cn-beijing.aliyuncs.com/activity/%E5%8F%B0%E5%8E%86/10.jpg'}
    ]
  },
  methods:{
      getSharedInfo(){
        let self = this;
        this.baseAjax({
            url:'/h5/getCard',
            showLoading:false,
            type:'post',
            data:{
                "type":"share_deskDiary",
                "returnType":"card",
            },
            success:function (data) {
                console.log(data)
                if(wxConfig.isWeiXin()){
                    let title = data.card.title
                    let desc = data.card.desc
                    let linkUrl = data.card.link
                    let imgUrl = data.card.imgUrl
                    wxConfig.wxConfigBuild_in(title,desc,linkUrl,imgUrl);
                }
            }
        })
      },
      signUp(){
          this.$router.push(`/deskDiaryMode`);
      },
      
    //   toggleContainerTouchAction(v) {
    //         const container = document.querySelector('.bigDiv')
    //         if (!container) {
    //             return
    //         }
    //         container.style['touch-action'] = v ? 'none' : 'auto'
    //   },
    //   stopTouch(e) {
    //       e.preventDefault()
    //   }
  }
}



// WEBPACK FOOTER //
// ./src/components/share/deskDiaryShare.vue